import RequestStatus from "../model/RequestStatus";
import {GetFeeCategoryListResponse} from "../model/FeeCategoryList";
import {
    FEE_CAT_QUERY_FAILED,
    FEE_CAT_QUERY_START,
    FEE_CAT_QUERY_SUCCESS,
    GetFeeCatQueryComplete
} from "../actions/FeeCategoryQueryAction";

const initFeeCategoryList = {
    trexIDToFeeCategoryMap: null,
    feeCategoryList: null,
    succeeded: null,
}

const initialState: GetFeeCategoryListResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    feeCategoryListResponse: initFeeCategoryList,
};

export default (
    state: GetFeeCategoryListResponse = initialState,
    action: GetFeeCatQueryComplete
): GetFeeCategoryListResponse => {
    switch (action.type) {
        case FEE_CAT_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                feeCategoryListResponse: initFeeCategoryList,
            };
        case FEE_CAT_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                feeCategoryListResponse: action.feeCatResponse,
            };
        case FEE_CAT_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                feeCategoryListResponse: null,
            };
        default:
            return state;
    }
};

